import React from 'react';

import { API } from 'aws-amplify';
import dayjs from 'dayjs';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { ContractActivityForm } from './Form';
import { Button } from '../../../components';

import './styles.scoped.css';

const CASForm = ({
  form,
  setForm,
  isLoadingCAS,
  isLoadingLOB,
  isLoadingBranches,
  casOptions,
  lobOptions,
  branchOptions,
  setLoadingResults,
  setData,
  setShowResults,
}) => {
  const navigate = useNavigate();
  const handleViewResults = async () => {
    if (
      !(
        dayjs(form?.ToPerEnddate).isAfter(form?.FromPerEnddate) ||
        dayjs(form?.FromPerEnddate).isSame(form?.ToPerEnddate)
      )
    ) {
      // eslint-disable-next-line no-undef
      alert('Invalid date range. Please double check and try again.');
      return;
    }
    setLoadingResults(true);
    try {
      const response = await API.post('centerlineportal', 'contract-activity-search', {
        body: {
          CAFromStartdate: form?.FromPerEnddate,
          CAToEnddate: form?.ToPerEnddate,
          CAStatus: form?.CAS,
          LineOfBusiness: form?.LOB,
          Branch: form?.branches,
          EmplLastName: form?.FromEmplLastName,
          EmplFirstName: form?.FromEmplFirstName,
          EmpId: +(form?.FromEmplID || 0),
        },
      });
      if (response.response_body?.length) {
        setLoadingResults(false);
        setData(response.response_body);
        setShowResults(true);
      } else {
        setLoadingResults(false);
        // eslint-disable-next-line no-undef
        alert('No data found matching your criteria.');
      }
    } catch (e) {
      setLoadingResults(false);
      // eslint-disable-next-line no-undef
      alert('No data found matching your criteria.');
      console.log('error: ', e);
    }
    setLoadingResults(false);
  };

  const handleChange = e => {
    const _form = { ...form, [e.target.name]: e.target.value };
    setForm(_form);
  };
  return (
    <Form
      noValidate
      onSubmit={() => {}}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <ContractActivityForm
        form={form}
        setForm={setForm}
        handleChange={handleChange}
        isLoadingCAS={isLoadingCAS}
        isLoadingLOB={isLoadingLOB}
        isLoadingBranches={isLoadingBranches}
        casOptions={casOptions}
        lobOptions={lobOptions}
        branchOptions={branchOptions}
      />

      <div className="buttons-row">
        <Button
          variant="primary"
          disabled={!form?.ToPerEnddate || !form?.FromPerEnddate}
          onPress={handleViewResults}
          style={{ marginRight: '20px', width: '100px' }}
          text="View"
        />

        <Button
          style={{ width: '100px' }}
          onPress={() => navigate('/edge-reporting')}
          variant="outline"
          text="Cancel"
        />
      </div>
    </Form>
  );
};

export default CASForm;
